; (function() {
  'use strict';

  var thanksCard = {
    config: {
      className: '.js-thanks-card',
      preview: {
        userClassName: '.js-thanks-user',
        titleClassName: '.js-thanks-title',
      },
      form: {
        userClassName: '.js-thanks-user-form',
        imageClassName: '.js-thanks-image-form',
        titleClassName: '.js-thanks-title-form',
        dataUser: 'thanks-user',
        dataImage: 'thanks-image',
      },
      themeRE: /card\-theme\-(\d+)/,
      customThemeRE: "custom_thanks_card",
    },
    $card: null,
    $user: null, $title: null,
    $userForm: null, $imageForm: null, $titleForm: null,

    init: function() {
      var config = this.config;
      this.$card = $(config.className);
      if (!this.$card.length) {
        return false;
      }

      var previewConfig = config.preview;
      this.$user = this.$card.find(previewConfig.userClassName);
      this.$title = this.$card.find(previewConfig.titleClassName);

      var formConfig = config.form;
      this.$userForm = $(formConfig.userClassName);
      this.$imageForm = $(formConfig.imageClassName);
      this.$titleForm = $(formConfig.titleClassName);

      this.preview();
      this.updatePreview();
    },

    preview: function() {
      var config = this.config;
      var formConfig = config.form;
      var _user, _image, _theme, _themeMatch, _customThemeMatch, _title;

      if (this.$userForm) {
        _user = this.$userForm.data(formConfig.dataUser);
        this.$user.attr('src', _user);
      }

      _theme = '1';
      if (this.$imageForm) {
        if (this.$imageForm.filter(':checked').length) {
          // カスタムサンクスはjsでbackground-imageを設定しているためここでリセットする
          this.$card.css('background', '');
          _image = this.$imageForm.filter(':checked').data(formConfig.dataImage);
          _themeMatch = _image.match(config.themeRE);
          _customThemeMatch = _image.includes(config.customThemeRE);

          if (_themeMatch) {
            _theme = _themeMatch[1];
          } else if (_customThemeMatch) {
            _theme = "custom-thanks-card"
            this.$card.css('background', 'url(' + _image + ') center top / cover no-repeat');
          }
          this.setTheme(_theme);
        }
      }

      if (this.$titleForm) {
        _title = this.$titleForm.val();
        this.$title.text(_title);
      }
    },

    updatePreview: function() {
      var self = this;

      this.$imageForm.on('change', function() {
        self.preview();
      });

      this.$titleForm.on('change', function() {
        self.preview();
      });
    },

    setTheme: function(themeId) {
      var config = this.config;
      var oldClasses = this.$card.attr('class');
      var newClasses = [];

      // class 設定を既存テーマから新テーマへ変更
      oldClasses.split(' ').forEach(function(_class) {
        if (!config.themeRE.test(_class) && _class !== "card-theme-custom-thanks-card") {
          newClasses.push(_class);
        }
      });
      newClasses.push('card-theme-' + themeId);
      this.$card.attr('class', newClasses.join(' '));
    }
  };

  /**
   * DOM content loaded
   */
  $(function() {
    thanksCard.init();
  });
}.call(this));
